import styled from 'styled-components'

import { ReactComponent as Eyelash } from '@sketch/icons/img-eye-slash-17'
import { Link, Text } from '@sketch/components'

export const Wrapper = styled.div`
  display: flex;
  margin: 0px 16px;
  align-items: center;
`

export const EyeIcon = styled(Eyelash)`
  width: 17px;
  height: 17px;
  color: ${({ theme }) => theme.colors.sketch.A};
  flex-shrink: 0;
`

export const StyledText = styled(Text)`
  margin-left: 8px;
  color: ${({ theme }) => theme.colors.foreground.secondary.C};
  font-size: ${({ theme }) => theme.fontSizes.D};
  /* To correctly vertically center the icon with the text */
  line-height: 1.4; /* stylelint-disable-line scales/line-heights */
`

export const Bold = styled.strong`
  font-weight: ${({ theme }) => theme.fontWeights.semibold};
`

export const StyledLink = styled(Link)`
  color: ${({ theme }) => theme.colors.foreground.secondary.C};
`
